import {
  createUniversalReporter,
  createSemanticMetrics,
} from '@spotify-internal/semantic-metrics';

const { sendMetric } = createSemanticMetrics({
  key: 's4mp-micro-frontends',
  reporter: createUniversalReporter(),
  // uncomment if the key is not the same as your component_id
  // component_id: 's4mp-micro-frontends',
});

export { sendMetric };
